"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_SHOW_CAPTCHA = exports.RESET_ADDITIONAL_INFORMATION = exports.UPDATE_INVITE_CODE_VISIBILITY = exports.IS_VALID_INVITE_CODE = exports.RESET = exports.CHECK_EMAIL = exports.REGISTER_PLAYER = exports.UPDATE_USER_REGISTRATION_DATA_FIELDS = exports.ERROR_RESET = exports.UPDATE_STEPPER = void 0;
const UPDATE_STEPPER = 'user_registration/UPDATE_STEPPER';
exports.UPDATE_STEPPER = UPDATE_STEPPER;
const ERROR_RESET = 'user_registration/ERROR_RESET';
exports.ERROR_RESET = ERROR_RESET;
const UPDATE_USER_REGISTRATION_DATA_FIELDS = 'user_registration/UPDATE_USER_REGISTRATION_DATA_FIELDS';
exports.UPDATE_USER_REGISTRATION_DATA_FIELDS = UPDATE_USER_REGISTRATION_DATA_FIELDS;
const IS_VALID_INVITE_CODE = 'user_registration/IS_VALID_INVITE_CODE';
exports.IS_VALID_INVITE_CODE = IS_VALID_INVITE_CODE;
const REGISTER_PLAYER = 'user_registration/REGISTER_PLAYER';
exports.REGISTER_PLAYER = REGISTER_PLAYER;
const CHECK_EMAIL = 'user_registration/CHECK_EMAIL';
exports.CHECK_EMAIL = CHECK_EMAIL;
const RESET = 'user_registration/RESET';
exports.RESET = RESET;
const UPDATE_INVITE_CODE_VISIBILITY = 'user_registration/UPDATE_INVITE_CODE_VISIBILITY';
exports.UPDATE_INVITE_CODE_VISIBILITY = UPDATE_INVITE_CODE_VISIBILITY;
const RESET_ADDITIONAL_INFORMATION = 'user_registration/RESET_ADDITIONAL_INFORMATION';
exports.RESET_ADDITIONAL_INFORMATION = RESET_ADDITIONAL_INFORMATION;
const UPDATE_SHOW_CAPTCHA = 'user_registration/UPDATE_SHOW_CAPTCHA';
exports.UPDATE_SHOW_CAPTCHA = UPDATE_SHOW_CAPTCHA;
//# sourceMappingURL=types.js.map